import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import SnackBar from '../../General/SnackBar';
import { useState } from 'react';
import { HandlePanVerify, VendorBankAccNumberVerify } from 'API/Procurement/VendorApis';
import BackdropLoader from '../../General/Loader';
import { ReturnPincodeData } from 'API/AgentOnboarding/api';
import { useEffect } from 'react';

const BasicForm = (props) => {
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [AlertOpen, setAlertOpen] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [IsBankVerified, setIsBankVerified] = useState(props.IsBankVerified);
  const [IsPanVerified, setIsPanVerified] = useState(props.IsPanVerified);
  const currentDate = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(
    currentDate.getDate()
  ).padStart(2, '0')}`;
  const formattedYesterday = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1).padStart(2, '0')}-${String(
    yesterday.getDate()
  ).padStart(2, '0')}`;

  const GeneralForm = [
    // { name: 'vendor_code', lable: 'Vendor Code', type: 'text',pattern:"^[a-zA-Z0-9]*$" },
    { name: 'vendor_name', lable: 'Vendor Name', type: 'text', pattern: '^[a-zA-Z ]*$', required: true },
    { name: 'company_name', lable: 'Company Name', type: 'text', pattern: '^[a-zA-Z0-9 ]*$', required: true },
    { name: 'dob', lable: 'DOB', type: 'date', required: true },
    { name: 'pan_number', lable: 'Pan Number', type: 'vertfy', pattern: '^[a-zA-Z0-9]*$', required: true },
    { name: 'mobile_number', lable: 'Mobile Number', type: 'text', pattern: '^[0-9]*$', required: true },
    { name: 'email_address', lable: 'Email Address', type: 'text', pattern: '^[a-zA-Z0-9@._]*$', required: true },
    { name: 'alternate_number', lable: 'Alternate Number', type: 'text', pattern: '^[0-9]*$' },
    { name: 'address', lable: 'Address', type: 'text', pattern: '^[a-zA-Z0-9/., ]*$', required: true },
    { name: 'pincode', lable: 'Pincode', type: 'text', pattern: '^[0-9]*$', required: true },
    { name: 'district', lable: 'District', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: false, required: true },
    { name: 'sub_district', lable: 'Sub District', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: false, required: true },
    { name: 'city_or_town', lable: 'City or Town', type: 'text', pattern: '^[a-zA-Z ]*$', required: true }
  ];

  const AccountForm = [
    { name: 'gst_number', lable: 'GST Number', type: 'text', pattern: '^[0-9a-zA-Z]*$', required: true },
    { name: 'bank_name', lable: 'Bank Name', type: 'text', pattern: '^[a-zA-Z ]*$', required: true },
    { name: 'ifsc_code', lable: 'IFSC Code', type: 'text', pattern: '^[a-zA-Z0-9]*$', required: true },
    { name: 'current_account_number', lable: 'Current Account Number', type: 'verify', pattern: '^[0-9]*$', required: true },
    { name: 'banc_ac_name', lable: 'Bank Account Name', type: 'text', pattern: '^[a-zA-Z ]*$', disabled: true, required: true }
  ];

  useEffect(() => {
    if (IsBankVerified && !props.IsBankVerified) {
      props.setIsBankVerified(IsBankVerified);
    }
  }, [IsBankVerified]);

  useEffect(() => {
    if (IsPanVerified && !props.IsPanVerified) {
      props.setIsPanVerified(IsPanVerified);
    }
  }, [IsPanVerified]);

  const handleFieldChange = (setFieldValue, name, value, pattern, values) => {
    // console.log("1");

    if (pattern) {
      // console.log("2");
      if (value.match(new RegExp(pattern))) {
        // console.log("3");
        if (value === ' ') {
          if (values[name].length > 0 && /^[a-zA-Z0-1]/.test(values[name])) {
            setFieldValue(name, value);
          } else {
            return;
          }
        } else if (name === 'pan_number') {
          if (values[name].length <= 9 || value.length <= 10) {
            setFieldValue(name, value.toUpperCase());
          }
        } else if (name === 'gst_number') {
          setFieldValue(name, value.toUpperCase());
        } else if (name === 'pincode') {
          if (values[name].length <= 5 || value.length <= 6) {
            setFieldValue(name, value);
            ReturnPincodeData(value).then((data) => {
              if (data) {
                setFieldValue('district', data[0].District);
                setFieldValue('sub_district', data[0].SubDistrict);
              }
            });
          }
        } else {
          setFieldValue(name, value);
        }
        return;
      }
    } else {
      setFieldValue(name, value);
    }
  };

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleVerify = (type, values, setFieldValue) => {
    switch (type) {
      case 'current_account_number': {
        if (values.current_account_number === null || values.current_account_number === '') {
          handleAlertOpen('Current Account Number cannot be empty', 'error');
          return false;
        } else if (values.ifsc_code === null || values.ifsc_code === '') {
          handleAlertOpen('IFSC Code cannot be empty', 'error');
          return false;
        } else {
          VendorBankAccNumberVerify(
            values.ifsc_code,
            values.current_account_number,
            setIsLoading,
            handleAlertOpen,
            setFieldValue,
            setIsBankVerified
          );
          break;
        }
      }
      case 'pan_number': {
        if (values.pan_number === null || values.pan_number === '') {
          handleAlertOpen('Pan Number cannot be empty', 'error');
          return false;
        } else if (values.vendor_name === null || values.vendor_name === '') {
          handleAlertOpen('Vendor Name cannot be empty', 'error');
          return false;
        } else if (values.dob === null || values.dob === '') {
          handleAlertOpen('Dob cannot be empty', 'error');
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(values.pan_number)) {
          handleAlertOpen('Invalid Pan Number', 'error');
          return false;
        } else {
          HandlePanVerify(values.pan_number, values.vendor_name, values.dob, setIsLoading, handleAlertOpen, setIsPanVerified);
        }
      }
    }
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <SnackBar message={AlertMessage} type={AlertType} open={AlertOpen} handleClose={handleAlertClose} />
      <BackdropLoader open={IsLoading} />
      <Formik
        initialValues={{
          vendor_code: props.PostData && props.PostData.vendor_code ? props.PostData.vendor_code : '',
          vendor_name: props.PostData && props.PostData.vendor_name ? props.PostData.vendor_name : '',
          company_name: props.PostData && props.PostData.company_name ? props.PostData.company_name : '',
          pan_number: props.PostData && props.PostData.pan_number ? props.PostData.pan_number : '',
          mobile_number: props.PostData && props.PostData.mobile_number ? props.PostData.mobile_number : '',
          email_address: props.PostData && props.PostData.email_address ? props.PostData.email_address : '',
          alternate_number: props.PostData && props.PostData.alternate_number ? props.PostData.alternate_number : '',
          address: props.PostData && props.PostData.address ? props.PostData.address : '',
          pincode: props.PostData && props.PostData.pincode ? props.PostData.pincode : '',
          district: props.PostData && props.PostData.district ? props.PostData.district : '',
          sub_district: props.PostData && props.PostData.sub_district ? props.PostData.sub_district : '',
          city_or_town: props.PostData && props.PostData.city_or_town ? props.PostData.city_or_town : '',
          gst_number: props.PostData && props.PostData.gst_number ? props.PostData.gst_number : '',
          ifsc_code: props.PostData && props.PostData.ifsc_code ? props.PostData.ifsc_code : '',
          current_account_number: props.PostData && props.PostData.current_account_number ? props.PostData.current_account_number : '',
          bank_name: props.PostData && props.PostData.bank_name ? props.PostData.bank_name : '',
          banc_ac_name: props.PostData && props.PostData.banc_ac_name ? props.PostData.banc_ac_name : '',
          dob: props.PostData && props.PostData.dob ? props.PostData.dob : ''
        }}
        validationSchema={Yup.object().shape({
          email_address: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
          vendor_code: Yup.string()
            .max(255)
            .matches(/^[a-zA-Z0-9]*$/, 'Vendor code must be alphanumeric'),
          vendor_name: Yup.string()
            .max(255)
            .matches(/^[a-zA-Z ]*$/, 'Vendor name must have only alphabets')
            .required('Vendor name is required'),
          company_name: Yup.string().max(255).required('Company name is required'),
          pan_number: Yup.string()
            .max(11, 'PAN Namuber must be max of 11 characters')
            .required('Pan number is required')
            .matches(/^[a-zA-Z1-9]*$/, 'Pan number must be alphanumeric'),
          mobile_number: Yup.string()
            .max(10, 'Mobile number must have maximum of 10 numbers')
            .min(10, 'Mobile number must have at least 10 numbers')
            .required('Mobile number is required')
            .matches(/^[0-9]*$/, 'Mobile number must be a number'),
          alternate_number: Yup.string()
            .max(10, 'Mobile number must have maximum of 10 numbers')
            .min(10, 'Mobile number must have at least 10 numbers')
            .matches(/^[0-9]*$/, 'Mobile number must be a number'),
          address: Yup.string().max(255).required('Address is required'),
          pincode: Yup.string()
            .max(255)
            .required('Pincode is required')
            .matches(/^[0-9]*$/, 'pincode must be a number'),
          district: Yup.string().max(255).required('District is required'),
          sub_district: Yup.string().max(255).required('Sub district is required'),
          city_or_town: Yup.string().max(255).required('City or town is required'),
          gst_number: Yup.string()
            .max(25, 'GST number must have maximum of 25 numbers')
            .matches(/^[0-9A-Z]*$/, 'GST number must be a number')
            .required('GST number is required'),
          ifsc_code: Yup.string()
            .max(255)
            .matches(/^[A-Za-z0-9]{11}$/, 'IFSC code must be 11 alphanumeric characters')
            .required('IFSC code is required'),
          current_account_number: Yup.string()
            .max(255)
            .matches(/^[0-9]*$/, 'Account number must be a number')
            .required('Account number is required'),
          bank_name: Yup.string().max(255).required('Bank name is required'),
          banc_ac_name: Yup.string().max(255).required('Please verify your bank account to get the name')
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            console.log('hit ok');

            setStatus({ success: true });
            setSubmitting(false);
            // props.setPostData({...props.PostData,...values})
            if (!IsBankVerified) {
              handleAlertOpen('Please verify your bank account', 'error');
            } else if (!IsPanVerified) {
              handleAlertOpen('Please verify your PAN', 'error');
            } else {
              props.handleNext(values);
            }
          } catch (err) {
            console.error(err);
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({
          errors,
          touched,
          // handleBlur, handleChange,
          handleSubmit,
          handleBlur,
          setFieldValue,
          values

          //  touched, values
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container>
              <Grid item xs={12}>
                <Box sx={{ border: '0.5px solid #e8e8e8', borderRadius: '10px', padding: 5, width: '100%' }}>
                  <Grid container spacing={2} justifyContent="flex-start">
                    {GeneralForm.map((item, index) =>
                      item.type === 'text' ? (
                        <Grid item xl={4} lg={4} key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">
                              {item.lable} <span style={{ color: 'red' }}>{item.required ? '*' : ''}</span>
                            </Typography>
                            <TextField
                              fullWidth
                              name={item.name}
                              disabled={
                                ((item.name === 'vendor_name' || item.name === 'pan_number') && IsPanVerified) || item.disabled
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleFieldChange(setFieldValue, item.name, e.target.value, item.pattern, values)}
                              onBlur={handleBlur}
                              value={values[item.name]}
                              size="small"
                            />
                            {errors[item.name] && touched[item.name] && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{errors[item.name]}</span>
                            )}
                          </div>
                        </Grid>
                      ) : item.type === 'date' ? (
                        <Grid item xl={4} lg={4} key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">
                              {item.lable} <span style={{ color: 'red' }}>{item.required ? '*' : ''}</span>
                            </Typography>
                            <TextField
                              fullWidth
                              name={item.name}
                              disabled={(item.name === 'dob' && IsPanVerified) || item.disabled ? true : false}
                              onChange={(e) => handleFieldChange(setFieldValue, item.name, e.target.value, item.pattern, values)}
                              onBlur={handleBlur}
                              value={values[item.name]}
                              size="small"
                              inputProps={{
                                max: item.name === 'dob' ? formattedYesterday : formattedDate
                              }}
                              type="date"
                            />
                            {errors[item.name] && touched[item.name] && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{errors[item.name]}</span>
                            )}
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xl={4} lg={4} key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">
                              {item.lable} <span style={{ color: 'red' }}>{item.required ? '*' : ''}</span>
                            </Typography>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <TextField
                                fullWidth
                                name={item.name}
                                disabled={IsPanVerified ? true : false}
                                onChange={(e) => handleFieldChange(setFieldValue, item.name, e.target.value, item.pattern, values)}
                                onBlur={handleBlur}
                                value={values[item.name]}
                                size="small"
                              />
                              <Button
                                variant="contained"
                                color="secondary"
                                disabled={IsPanVerified ? true : false}
                                size="small"
                                onClick={() => handleVerify(item.name, values, setFieldValue)}
                              >
                                {IsPanVerified ? 'verified' : 'Verify'}
                              </Button>
                            </Stack>
                            {errors[item.name] && touched[item.name] && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{errors[item.name]}</span>
                            )}
                          </div>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12} mt={1}>
                <Box sx={{ border: '0.5px solid #e8e8e8', borderRadius: '10px', padding: 5, width: '100%' }}>
                  <Grid container spacing={2} justifyContent="flex-start">
                    {AccountForm.map((item, index) =>
                      item.type === 'text' ? (
                        <Grid item xl={4} lg={4} key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">
                              {item.lable} <span style={{ color: 'red' }}>{item.required ? '*' : ''}</span>
                            </Typography>
                            <TextField
                              fullWidth
                              name={item.name}
                              disabled={(item.name === 'ifsc_code' && IsBankVerified) || item.disabled ? true : false}
                              onChange={(e) => handleFieldChange(setFieldValue, item.name, e.target.value, item.pattern, values)}
                              onBlur={handleBlur}
                              value={values[item.name]}
                              size="small"
                            />
                            {errors[item.name] && touched[item.name] && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{errors[item.name]}</span>
                            )}
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xl={4} lg={4} key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5">
                              {item.lable} <span style={{ color: 'red' }}>{item.required ? '*' : ''}</span>
                            </Typography>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <TextField
                                fullWidth
                                name={item.name}
                                disabled={item.name === 'current_account_number' && IsBankVerified ? true : false}
                                onChange={(e) => handleFieldChange(setFieldValue, item.name, e.target.value, item.pattern, values)}
                                onBlur={handleBlur}
                                value={values[item.name]}
                                size="small"
                              />
                              <Button
                                disabled={IsBankVerified}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => handleVerify(item.name, values, setFieldValue)}
                              >
                                {IsBankVerified ? 'Verified' : 'verify'}
                              </Button>
                            </Stack>
                            {errors[item.name] && touched[item.name] && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{errors[item.name]}</span>
                            )}
                          </div>
                        </Grid>
                      )
                    )}
                  </Grid>
                  <Stack direction="row" justifyContent="flex-end">
                    <Button
                      onClick={handleSubmit}
                      sx={{
                        minWidth: '150px',
                        mr: 1,
                        backgroundColor: '#688B3A',
                        color: '#FFFFFF',
                        borderRadius: '6px',
                        '&:hover': {
                          backgroundColor: '#688B3A'
                        }
                      }}
                      color="secondary"
                      variant="contained"
                      size="medium"
                    >
                      Next
                    </Button>
                    {errors.submit && touched.submit && <span style={{ color: 'red', fontSize: '12px' }}>{errors.submit}</span>}
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default BasicForm;
